import { createAction, createFeatureSelector, createReducer, createSelector, on, props } from '@ngrx/store';

import { TurnoverAuditMode } from '@shared/enums/turnover-audit-mode';
import { TurnoversFilters } from '@shared/interfaces/turnovers-filters.interface';

export const dashboardFilterTransientFeatureKey = 'dashboardFilterTransient';

export const selectDashboardsStateTransient = createFeatureSelector<DashboardsStateTransient>(
  dashboardFilterTransientFeatureKey
);

/**
 * dashboards filters
 */
export const selectTurnoversFilters = createSelector(
  selectDashboardsStateTransient,
  dashboardsState => dashboardsState.turnoversFilters
);

export interface DashboardsStateTransient {
  turnoversFilters: TurnoversFilters;
}

/**
 * set turnovers filters
 */
export const setTurnoversFilters = createAction(
  '[Dashboard] set turnovers filters',
  props<{ turnoversFilters: TurnoversFilters }>()
);

export const updateTurnoversFilters = createAction(
  '[Dashboard] update turnovers filters',
  props<{ turnoversFilters: Partial<TurnoversFilters> }>()
);

export const resetTurnoversFilters = createAction('[Dashboard] reset turnovers filters');

export const initialState: DashboardsStateTransient = {
  turnoversFilters: {
    auditMode: TurnoverAuditMode.ELAPSED_DAYS,
  },
};

export const reducer = createReducer(
  initialState,
  /**
   * turnovers filters
   */
  on(setTurnoversFilters, (state, action) => ({
    ...state,
    turnoversFilters: action.turnoversFilters,
  })),
  on(updateTurnoversFilters, (state, action) => ({
    ...state,
    turnoversFilters: { ...state.turnoversFilters, ...action.turnoversFilters },
  })),
  on(resetTurnoversFilters, (state, action) => ({
    ...state,
    turnoversFilters: initialState.turnoversFilters,
  }))
);
